import { render } from "./P010.vue?vue&type=template&id=36b915ef&scoped=true"
import script from "./P010.vue?vue&type=script&lang=js"
export * from "./P010.vue?vue&type=script&lang=js"

import "./P010.vue?vue&type=style&index=0&id=36b915ef&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36b915ef"]])

export default __exports__